import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stripParagraphs', standalone: true })
export class StripParagraphsPipe implements PipeTransform {
  transform(value: string): string {
    // Remove the first paragraph, replace all others with linebreaks
    return value?.replace('<p>', '').replace('</p>', '').replaceAll('<p>', '<br/>').replaceAll('</p>', '<br/>');
  }
}
